import { StoreState } from "../../models/reduxModels";

let savedUser = undefined;
try {
  const savedUserStr = localStorage.getItem("user");
  if (savedUserStr) {
    const parsed = JSON.parse(savedUserStr);
    if (parsed && parsed.is_reset_password) {
      localStorage.removeItem("user");
    } else {
      savedUser = parsed;
    }
  }
} catch (e) {
  console.error("Error parsing user from localStorage:", e);
}

const InitialState: StoreState = {
  user: {
    userDetails: savedUser || undefined,
    sideNavClose: false,
    get_all_notification: [],
    offer_letter_list: [],
  },
  error: {
    error: undefined,
  },
  loading: {
    count: 0,
    message: "",
    type: 0,
  },
  organization: {
    organization_filter_list: [],
    organization_pagination: {
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      totalPages: 0,
    },
    department_list: [],
    department_total_count: 0,
    department_pagination: {
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      totalPages: 0,
    },
    service_list: [],
    designation_list: [],
    designation_pagination: {
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      totalPages: 0,
    },
    employee_timing_list: [],
    employee_timing_pagination: {
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      totalPages: 0,
    },
    employee_type_list: [],
    employee_type_pagination: {
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      totalPages: 0,
    },
    component_list: [],
    domain_list: [],
    salary_priod: [],
    salary_structure_list: [],
    salary_structure_edit: undefined,
    post_list: [],
    calculation_type: [],
    operator: [],
    global_key: [],
    operator_tye: [],
    currentMonthBirthday: [],
    createEmpOnMonth: [],
    recentAnnouncements: [],
    empPresents: [],
    unseenNotiCount: 0,
    salary_compo_threshold: [],
    event_action: [],
    event_type: [],
    project_document: [],
    attendance_platform_list: [],
    skills: [],
    holidaysList: [],
    org_bulk_status_list: [],
    org_bulk_status_total: 0,
  },
  customer: {
    customer_list: [],
    project_list: [],
    division_list: [],
    subdivision_list: [],
    project_detail: undefined,
    project_attendance_template: [],
    project_levels: undefined,
    project_dashboard_details: undefined,
    attendence_status: [],
    project_dashboard_batch_details: [],
    project_employee_payroll_details: [],
    level_hierachy: undefined,
    set_level_value: [],
    level_tree: undefined,
    available_emp_list: [],
    project_budget_list: [],
    project_unbuget_list: [],
    project_payment_list: [],
    state_list: [],
    budget_details: undefined,
    level_master: [],
    location_levels: [],
    levels_details: [],
    consolidated_report: undefined,
    month_wise_emp_salary_Budgeting: [],
    emp_salary_month_projectwise: [],
    pending_project_closure: [],
    completed_project_list: [],
  },
  employee: {
    event_list: [],
    refferal_list: [],
    refferal_count: undefined,
    employee_detail: undefined,
    ReportingManagerList: [],
    filter: [],
    candidate_list: [],
    candidate_count: undefined,
    attendence_salary_type: [],
    employee_list: [],
    employee_count: undefined,
    action_event_list: [],
    //employee_all_details: [],
    bank_list: [],
    employeeDetails: undefined,
    present_address: undefined,
    permanent_address: undefined,
    documents_details: [],
    education_details: [],
    experience_details: [],
    ProjectAssociationWithLevelName: [],
    designation_name_with_details: [],
    EmployeeAttendanceReport: [],
    SalaryDetail: [],
    SalaryHistory: [],
    candidateBulkUploadList: [],
    candidateBulkUploadTotal: 0,
    professional_details: [],
    employee_pdf_list: [],
    reporting_manager_details: [],
    myTeamList: [],
    employeeLocationsLists: [],
    employeeImages: [],
    reportingManagerOrgList: [],
    reportingManagerSearchList: [],
    employeeTransferRequests: [],
    employeeTransferRequestsCount: 0,
    employeeTransferRequestsPagination: {
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      totalPages: 0,
    },
    searchEmployeeList: [],
  },
  attendance: {
    // attendance_dashboard: undefined,
    attendance_dashboard: [],
    pending_approval: [],
    upload_attendance_view: [],
    employee_list: [],
    total_count: undefined,
    attendance_approve_list: [],
    attendence_fields: [],
    attendance_timesheet_list: [],
    get_all_emp_monthly_attendece: [],
    monthly_attendance_count: 0,
    pending_attendance_list: [],
    view_team_attendance: [],
    view_team_attendance_count: 0,
    dashboard_details: null,
    get_all_timesheet_details_today: [],
    approval_temp: null,
    attendance_failure_logs: [],
    attendance_failure_logs_count: 0,
    attendance_failure_log_detail: null,
  },
  userManagement: {
    access_control_master: [],
    all_role_master: [],
    role_get_by_id: undefined,
    user_role_mapping_list: undefined,
    all_user_lists: [],
    all_user_pagination: undefined,
    all_role_pagination: undefined,
  },
  setUpDetails: {
    desgination_id: 42,
  },
};

export default InitialState;
